module.exports = __webpack_public_path__ + "static/media/image_1_1.4d3dec6b.png";